import Logger from 'wanderu-logger';
import { SnowplowService } from 'wanderu-service-analytics';
import { TixService } from 'wanderu-service-wapi';

import { UnableToRetrieveTicketError } from './Errors';
import Events from './events/BookedTripEvents';
import { wait } from './utils';

const logger = Logger.getLogger('BookedTrip');
const MAX_TRIES = 5;
const TIMEOUT_INTERVAL = 1000;
const AVAILABLE = 'available';

async function fetchTicketUrl(urlForPollingTicket, processingId, ticketType) {
    const ticketResult = await _tryMultipleTimes(async () => {
        return await TixService.get(urlForPollingTicket);
    });

    const downloadTicketEvent = Events.createDownloadTicketEvent({
        processingId,
        ticketType,
    });

    SnowplowService.fireStructuredEvent(downloadTicketEvent);

    return ticketResult.url;
}

async function _tryMultipleTimes(fn) {
    for (let i = 0; i < MAX_TRIES; i++) {
        const response = await fn();

        if (response.result.status === AVAILABLE) {
            return response.result;
        }

        await wait(TIMEOUT_INTERVAL * (i + 1));
    }

    logger.error('_tryMultipleTimes', `Unable to retrieve ticket after ${MAX_TRIES} attempts.`);
    throw new UnableToRetrieveTicketError();
}

export default {
    fetchTicketUrl,
};
